import React, { useState, useEffect } from 'react';
import { FaTimes, FaCheck } from "react-icons/fa";
import './Web3Quiz.css';
import { QuizQuestionsApi, submitQuizScore } from '../../../apis/iplBattle';
import useUserInfo from '../../../Hooks/useUserInfo';
import { userGameRewards } from '../../../apis/user';
import Task from '../Task';
import { useAudio } from '../../../Providers/AudioProvider';
import { logPageView } from '../../../components/analytics';

const Web3Quiz = () => {
    const { userDetails, updateUserInfo } = useUserInfo();
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [answered, setAnswered] = useState(false);
  const [showScore, setShowScore] = useState(false);
  const [score, setScore] = useState(0);
  const [quizComplete, setQuizComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [answeredQuestions, setAnsweredQuestions] = useState({});
  const playClick = useAudio();
  const IsProd = process.env.REACT_APP_IS_PROD=="true"?true:false;

  useEffect(() => {
    checkQuizAvailability();
    IsProd &&  logPageView("Web3Quiz ", "Web3 Quiz");
  }, []);

  const checkQuizAvailability = async () => {
    const lastQuizDate = localStorage.getItem(`lastQuizDate_${userDetails?.userDetails?.telegramId}`);
    const today = new Date().toDateString();
  
    if (lastQuizDate === today) {
      setQuizComplete(true);
      setScore(parseInt(localStorage.getItem(`lastQuizScore_${userDetails?.userDetails?.telegramId}`) || '0'));
    } else {
      await fetchQuestions();
  
      // Load saved progress
      const savedProgress = localStorage.getItem(`web3QuizProgress_${userDetails?.userDetails?.telegramId}`);
      if (savedProgress) {
        const { currentQuestionIndex, score, answeredQuestions } = JSON.parse(savedProgress);
        setCurrentQuestionIndex(currentQuestionIndex || 0);
        setScore(score || 0);
        setAnsweredQuestions(answeredQuestions || {});
        if (answeredQuestions && answeredQuestions[currentQuestionIndex]) {
          setSelectedOption(answeredQuestions[currentQuestionIndex].selectedOption);
          setAnswered(true);
        }
      }
    }
  };

  const fetchQuestions = async () => {
    try {
        updateUserInfo((prev) => ({
            ...prev,
            isLoading: true,
          }));
      const response = await QuizQuestionsApi();
      console.log('API Response:', response);
      
      if (response && Array.isArray(response)) {
        setQuestions(response);
      } else if (response && response.questions && Array.isArray(response.questions)) {
        setQuestions(response.questions);
      } else {
        console.error('Invalid response format:', response);
      }
    } catch (error) {
      console.error('Error fetching questions:', error);
    } finally {
        updateUserInfo((prev) => ({
            ...prev,
            isLoading: false,
          }));
    }
  };

  const handleAnswerOptionClick = (option) => {
    if (answered || answeredQuestions[currentQuestionIndex]) return;
    
    setSelectedOption(option);
    setAnswered(true);
    
    const isCorrect = option === questions[currentQuestionIndex].correctAnswer;
    if (isCorrect) {
      setScore(prev => prev + 1);
    }

    // Store answered question
    const newAnsweredQuestions = {
      ...answeredQuestions,
      [currentQuestionIndex]: {
        selectedOption: option,
        isCorrect
      }
    };
    setAnsweredQuestions(newAnsweredQuestions);

    // Save to localStorage
    localStorage.setItem(`web3QuizProgress_${userDetails?.userDetails?.telegramId}`, JSON.stringify({
      currentQuestionIndex,
      score: isCorrect ? score + 1 : score,
      answeredQuestions: newAnsweredQuestions
    }));
  };

  const handleNextQuestion = async () => {
    const nextIndex = currentQuestionIndex + 1;
  
    // Save progress before moving to next
    localStorage.setItem(`web3QuizProgress_${userDetails?.userDetails?.telegramId}`, JSON.stringify({
      currentQuestionIndex: nextIndex,
      score,
      answeredQuestions
    }));
  
    if (nextIndex < questions.length) {
      setCurrentQuestionIndex(nextIndex);
      setSelectedOption(answeredQuestions[nextIndex]?.selectedOption || null);
      setAnswered(!!answeredQuestions[nextIndex]);
    } else {
      setShowScore(true);
      setQuizComplete(true);
  
      const today = new Date().toDateString();
      localStorage.setItem(`lastQuizDate_${userDetails?.userDetails?.telegramId}`, today);
      localStorage.setItem(`lastQuizScore_${userDetails?.userDetails?.telegramId}`, score.toString());
      localStorage.removeItem(`web3QuizProgress_${userDetails?.userDetails?.telegramId}`); // Clear progress on completion
  
      try {
        setIsSubmitting(true);
        const points = score * 100;
        if (points>0){
        await userGameRewards({
          gameType: 'web3Quiz',
          gamePoints: String(points),
          chancesToPlayed:5,
        });
      }
      else {
        setIsSubmitting(false);
      }
      } catch (error) {
        console.error('Error submitting score:', error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const toogleMenu = () => {
    if (!isSubmitting)
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: Task,
      currentComponentText: "Task",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
    playClick();
  };

  return (

      <div
        className="menupointer"
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          flexDirection: "column",
          pointerEvents: "all",
          marginTop: "60px",
        }}
      >
        <div className="quiz-play-task-web">
          <img
            src='https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg'
            className="cancel-imgpoints"
            style={{ cursor: "pointer" }}
            onClick={toogleMenu}
          />
          <h1 className="welcome-text">Web3 Quiz</h1>

          {quizComplete ? (
            <div className="cards1">
              <h1 className="title-epic1 text-uppercase">Quiz Completed!</h1>
              <div className="pointsContainer">
                <div className="pointsInnerContainer1">
                  <p className="pointsLabel1">SCORE:{score}/5</p>
                  <div className="pointsValueweb">
                    <p className="points-earned">Tokens Earned: {score * 100}</p>
                  </div>
                </div>
              </div>
              <p className="bottom-text">
                {isSubmitting ? 'Submitting score...' : 'Come back tomorrow for more questions!'}
              </p>
            </div>
          ) : showScore ? (
            <div className="cards">
              <h1 className="title-epic">{score > 3 ? "Epic Win!" : "Better Luck Next Time!"}</h1>
              <div className="pointsContainer">
                <div className="pointsInnerContainer">
                  <p className="pointsLabel">SCORE</p>
                  <div className="pointsValue">
                    <p className="pointsNumber">{score}/5</p>
                  </div>
                </div>
              </div>
              <p className="bottom-text">
                Play daily to boost your score <br /> and rack up more points!
              </p>
            </div>
          ) : (
            <>
              <div className="question-count">
                <span>YOU HAVE {questions.length - currentQuestionIndex}</span>/5 Question
              </div>

              {questions.length > 0 && (
                <div className="question-section">
                  <div className="question-text">
                    {questions[currentQuestionIndex]?.question}
                  </div>
                  <div className="answer-section">
                    {questions[currentQuestionIndex]?.options.map((option, index) => {
                      const isAnswered = answeredQuestions[currentQuestionIndex];
                      const wasSelected = isAnswered?.selectedOption === option;
                      const isCorrect = option === questions[currentQuestionIndex].correctAnswer;
                      
                      return (
                        <button
                          key={option}
                          onClick={() => handleAnswerOptionClick(option)}
                          style={{
                            backgroundColor:
                              isAnswered
                                ? wasSelected
                                  ? isCorrect
                                    ? "green"
                                    : "red"
                                  : isCorrect
                                  ? "green"
                                  : "initial"
                                : answered && selectedOption === option
                                ? option === questions[currentQuestionIndex].correctAnswer
                                  ? "green"
                                  : "red"
                                : "initial",
                            color: "white",
                          }}
                          disabled={isAnswered || answered}
                        >
                          <span className="option-letter">{String.fromCharCode(97 + index)}.</span> {option}
                          {(isAnswered || answered) && (
                            <>
                              {wasSelected && !isCorrect && (
                                <FaTimes style={{ marginLeft: "10px", color: "white" }} />
                              )}
                              {isCorrect && (
                                <FaCheck style={{ marginLeft: "10px", color: "white" }} />
                              )}
                            </>
                          )}
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}

              <button
                onClick={handleNextQuestion}
                disabled={!answered && !answeredQuestions[currentQuestionIndex]}
                className="quitz-btn"
              >
                Next
              </button>
            </>
          )}
        </div>
      </div>

  );
};

export default Web3Quiz;
